import React, { lazy, Suspense } from 'react';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import { Admins, Props as WidgetProps } from './Admins';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import reduxConnectContainer from './Admins.container';
import ChunkLoadingPopover from '../_partials/ChunkLoadingPopover';
import EmptyState from '../../EmptyState';

import s from './Admins.scss';

const AdminsConfigPopover = lazy(() =>
  import(/* webpackChunkName: "owner" */ './AdminsConfigPopover')
);
const enhance = compose(reduxConnectContainer);

const AdminsBox: React.FC<WidgetProps &
  WidgetBoxProps & { isEmpty: boolean }> = ({
  widgetMoveUp,
  widgetMoveDown,
  widgetRemove,
  section,
  zone,
  isEmpty,
  ...props
}) => {
  const { t } = useTranslation();
  const { moduleId } = props;

  return (
    <WidgetBox
      section={section}
      zone={zone}
      header={t(`widgets.admins.header`)}
      moduleId={moduleId}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
      widgetMenuRenderer={close => (
        <Suspense fallback={<ChunkLoadingPopover />}>
          <AdminsConfigPopover moduleId={moduleId} onClose={close} />
        </Suspense>
      )}
      isEmpty={isEmpty}
      emptyView={
        <EmptyState
          view="small"
          className={s['empty-state']}
          titleClassName={s['empty-state-title']}
          title={t(`widgets.admins.empty.title.visitor`)}
          subtitle={t(`widgets.admins.empty.subtitle.visitor`)}
        />
      }
    >
      <Admins {...props} />
    </WidgetBox>
  );
};

export default enhance(AdminsBox);
